import { render, staticRenderFns } from "./ClimateOnlinePayment.vue?vue&type=template&id=23235041"
import script from "./ClimateOnlinePayment.vue?vue&type=script&lang=js"
export * from "./ClimateOnlinePayment.vue?vue&type=script&lang=js"
import style0 from "./ClimateOnlinePayment.vue?vue&type=style&index=0&id=23235041&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports